import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught an error:', error, info);
  }

  handleGoHome() {
    window.location.href = '/auth-home';
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '2rem',
          textAlign: 'center',
          fontFamily: 'sans-serif',
        }}>
          <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Oops, something went wrong</h1>
          <p style={{ color: '#666', marginBottom: '2rem', maxWidth: '400px' }}>
            We're sorry for the inconvenience. Thank you for your patience — please head back home and we'll get this sorted.
          </p>
          <button
            onClick={this.handleGoHome}
            style={{
              padding: '0.75rem 1.5rem',
              fontSize: '1rem',
              cursor: 'pointer',
              borderRadius: '6px',
              border: 'none',
              backgroundColor: '#333',
              color: '#fff',
            }}
          >
            Go to home
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <pre style={{
              marginTop: '2rem',
              padding: '1rem',
              backgroundColor: '#f5f5f5',
              borderRadius: '6px',
              fontSize: '0.8rem',
              textAlign: 'left',
              maxWidth: '600px',
              overflowX: 'auto',
              color: '#c00',
            }}>
              {this.state.error.toString()}
            </pre>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
